import { render, staticRenderFns } from "./slide-in.vue?vue&type=template&id=460bb838&scoped=true&"
import script from "./slide-in.vue?vue&type=script&lang=js&"
export * from "./slide-in.vue?vue&type=script&lang=js&"
import style0 from "./slide-in.vue?vue&type=style&index=0&id=460bb838&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460bb838",
  null
  
)

export default component.exports